/**
 * Types for Drag the Words prompt form
 */

import type { UploadedDocument } from '../types';

export type { UploadedDocument };

export type DragWordsMediaType = 'none' | 'passage' | 'image' | 'audio';

export type DragWordsSourceType = 'topic' | 'document';

export interface DragWordsFormState {
    media: DragWordsMediaType;
    // WHY: State keys match Agent recipe settings so option payload needs no rename.
    // No ticket on main; SSOT GEN_QUESTION_CONTRACT + agents/01_hub_fe.md.
    num_blanks: number;
    distractors_per_blank: number;
    sourceType: DragWordsSourceType;
    description: string;
    documents: UploadedDocument[];
}

export const MEDIA_OPTIONS: { value: DragWordsMediaType; label: string }[] = [
    { value: 'none', label: 'None' },
    { value: 'passage', label: 'Passage' },
    { value: 'image', label: 'Image' },
    { value: 'audio', label: 'Audio' },
];

// WHY: Mirror Agent GapQuestionTypeConfig — blanks 1..15; distractors 1..5
// (Field ge=1). FE follows pydantic SoT, not recipe_resolve's 0 allowance.
export const MIN_NUM_BLANKS = 1;
export const MAX_NUM_BLANKS = 15;
export const MIN_DISTRACTORS_PER_BLANK = 1;
export const MAX_DISTRACTORS_PER_BLANK = 5;

export const DEFAULT_FORM_STATE: DragWordsFormState = {
    media: 'none',
    num_blanks: 1,
    distractors_per_blank: 2,
    sourceType: 'topic',
    description: '',
    documents: [],
};

export const DOCUMENT_ACCEPT = '.pdf,.txt,.doc,.docx,.rtf';
